import { ToastrService } from 'ngx-toastr';
import { AssignedStudentAttempt, Assignment, UnAssignModel } from './../../../Elearning-Models';
import { Subscription } from 'rxjs';
import { AssignmentFilterService } from '../../../Services/filter.service';
import { SelectionService } from '../../../Services/selection.service';
import { DatePipe } from '@angular/common';
import { GradebookDataService } from '../../../Services/gradebookData.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IServiceFactory } from '../../../Services/service-factory';
import { environment } from '../../../../environments/environment';
import { ReleaseAllDialogComponent } from '../shared/release-all-dialog/release-all-dialog.component';
import { AssignmentVM } from 'src/app/Elearning-Models';
import { MatAccordion } from '@angular/material/expansion';
import { UnassignDiaglogComponent } from '../shared/unassign-diaglog/unassign-diaglog.component';

@Component({
  selector: 'app-assignment',
  templateUrl: './assignment.component.html',
  styleUrls: ['./assignment.component.scss'],
})
export class AssignmentComponent implements OnInit, OnDestroy { showCreateAssignments: boolean = false;
  @ViewChild(MatAccordion) accordion: MatAccordion;

  filterSubscription: Subscription;
  assignment: AssignmentVM;
  lessonVersionId: number;
  assignmentName: string;
  curriculumDataReceived: boolean = false;
  startDate: string;
  dueDate: string;
  curriculum: any;
  classID: number;
  assignmentsObject: {
    [key: number] : AssignedStudentAttempt[]
  } = {};
  filterValue: any;
  filteredStudents: AssignedStudentAttempt[];
  isExpanded: boolean = true;
  Object = Object;
  private gradebookDataService: GradebookDataService;
  filterService: AssignmentFilterService;
  dataService: GradebookDataService;
  selectionService: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private router: Router,
    public dialog: MatDialog,
    private serviceFactory: IServiceFactory,
    private toastr: ToastrService
  ) {
    this.dataService = serviceFactory.getGradebookDataService();
    this.filterService = serviceFactory.getAssignmentFilterService();
    this.selectionService = serviceFactory.getSelectionService();
  }

  ngOnInit(): void {
    this.dataService.ShowGradebookStudentAssignmentCreateAssignmentInterface().subscribe( result => {
      this.showCreateAssignments = result;
    });
    this.classID = +this.selectionService.getClassID();
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.lessonVersionId = +params.get('lvid');
    });

    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.assignmentName = queryParams.get('assignmentName');
    });

    this.getAssignmentDetails();

    this.filterSubscription = this.filterService.currentFilterValue.subscribe(
      (filterValue) => {
        this.filterValue = filterValue;
        if (this.curriculumDataReceived) {
          this.filterStudents();
        }
      }
    );
  }

  getAssignmentDetails = () => {
    // this.curriculumDataReceived = false;
    this.dataService.GetLessonProgressByLessonVersionID(
      this.classID,
      this.lessonVersionId
    ).subscribe((response: AssignmentVM) => {
      this.assignment = response;
      this.createAssignmentsObject(this.assignment.AssignedStudentAttempts);
      this.filteredStudents = this.assignment.AssignedStudentAttempts;
      this.filterValue = this.filterService.getFilterValue();
      this.filterStudents();
      this.transformDate();
      this.curriculumDataReceived = true;
    });
  };

  createAssignmentsObject = (students: AssignedStudentAttempt[]) => {
    this.assignmentsObject = {}
    students?.map(student => {
      if (!this.assignmentsObject[student.AssignmentID]) {
        this.assignmentsObject[student.AssignmentID] = [];
      }
      this.assignmentsObject[student.AssignmentID].push(student);
    })
  }

  transformDate = () => {
    this.startDate = this.datePipe.transform(
      new Date('01-01-2021'),
      // new Date(this.assignment.StartDate),
      'MM-dd-yyyy'
    );
    this.dueDate = this.datePipe.transform(
      new Date('01-01-2021'),
      // new Date(this.assignment.DueDate),
      'MM-dd-yyyy'
    );
  };

  filterStudents = () => {
      this.filteredStudents = [];
      this.assignment.AssignedStudentAttempts?.map((s) => {
        if (this.filterService.showData(s)) {
          this.filteredStudents.push(s);
        }
      });
    this.createAssignmentsObject(this.filteredStudents);
  };

  onUnassignAll(){
    const dialogRef = this.dialog.open(UnassignDiaglogComponent, {
			data: {
			  lessonName: this.assignmentName,
			},
			autoFocus: false,
		  });
	  
	  
		  const sub = dialogRef.componentInstance.unassignYes.subscribe(
			(result: boolean) => {
			  if(result){
				this.onUnassignAllClick();
			  }
			}
		  );
	  
		  dialogRef.afterClosed().subscribe((result) => {
			sub.unsubscribe();
		  });
  }
  onUnassignAllClick(){
    var model = new UnAssignModel();
    model.ClassID = this.classID;
    model.LessonVersionID = this.assignment.LessonID;
    model.StudentID = null;
    this.dataService.UnassignOneOrAll(model).subscribe(result => {
      if(result){
        this.toastr.success(this.assignmentName + " was successfully unassigned from everyone.");
      }
      else{
        this.toastr.error('Something went wrong', 'Failure!');
      }
    });
  }

  onReleaseAll = () => {
    const dialogRef = this.dialog.open(ReleaseAllDialogComponent, {
      data: {
        data: this.assignment.AssignedStudentAttempts,
        title: this.assignment.LessonName,
        type: 'Students',
        // id: this.student.StudentID
      },
      autoFocus: false,
      panelClass: 'app-release-all-dialog'
    });

    const sub = dialogRef.componentInstance.releaseAllSelected.subscribe(
      (selectedValues) => {
        this.dataService.ReleaseAllGradesByAssignmentID({
          Threshold: selectedValues.threshold,
          Reassign: selectedValues.reassign,
          ClassID: this.assignment.ClassDetails.ClassID,
          ReassignShowIcon: selectedValues.reassignOption,
          ReassignShowAnswer: selectedValues.reassignSubOption,
          AssignmentID: this.assignment.AssignedStudentAttempts[0].AssignmentID
        }).subscribe((response: boolean) => {
          if (response) {
            this.toastr.success('All Students Released', 'Success!');
          } else {
            this.toastr.error('Something went wrong', 'Failure!');
          }
        })
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      sub.unsubscribe();
    });
  };

  trackByFn(index, item) {
    return index; // or item.id
  }

  toClass = () => {
    const currentClass = localStorage.getItem('classID');
    if (currentClass) {
      this.router.navigate([environment.rootPath + 'Class/' + currentClass]);
    } else {
      // this.router.navigate([environment.rootPath + 'landing']);
    }
  }

  navigateToID = (ID) => {
    const yOffset = -18;
    const element = document.getElementById(ID);
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
  }

  onExpandAll = () => {
    this.accordion.openAll();
  }

  onCollapseAll = () => {
    this.accordion.closeAll();
  }

  ngOnDestroy(): void {
    this.filterSubscription.unsubscribe();
  }

  /**
   * This method is used to assign to class with assignment id.
   */
  redirectToAssignedClass = () => {
    this.router.navigate(
      [environment.rootPath + 'Class/' + this.classID],
      {
        queryParams: {
          assignmentId: this.lessonVersionId
        },
      }
    );
  }
}
